import {gql} from '@apollo/client'

export const ANULAR_VALIDATION = gql`
  mutation identityValidationAnnular($input: IdentityValidationURLBuilderInput!) {
    identityValidationAnnular(input: $input) {
      success
      errors {
        message
      }
    }
  }
`

export const SOLICITAR_URL = gql`
  mutation identityValidationUrlBuilder($input: IdentityValidationURLBuilderInput!) {
    identityValidationUrlBuilder(input: $input) {
      url
      success
      errors {
        message
      }
    }
  }
`
